import { UndergradLesson } from '@/models/undergrad/undegrad-lesson.model';

export enum VideoType {
  VOD = 'VOD',
  RERUN = 'RERUN',
  LIVE = 'LIVE',
}

export interface UndergradVideo {
  id: string;
  name: string;
  slug: string;
  type: VideoType;
  kalturaId?: string;
  youtubeId?: string;
  livestreamUrl?: string;
  zoomId?: string;
  imageUrl?: string;
  faculLessons?: UndergradLesson[];
  transmissionStartDate: Date;
  transmissionEndDate: Date;
  estimatedDurationInMinutes?: number;
}
